import ProjectCard from "components/card/ProjectCard";

import styled from "styled-components";
import { BlueButton, Container, Title, TopTitle } from "styles/Common";

import { device } from "styles/Breakpoint";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import { useRouter } from "next/router";

interface props {
  data: IProject[];
  hasPrevious: boolean;
  hasNext: boolean;
}

function index({ data, hasPrevious, hasNext }: props) {
  const { t } = useTranslation("common");
  const page = Number(useRouter().query.page) || 1;

  return (
    <SectionWorks>
      <Container>
        <TopTitle>{t("works.my-works")}</TopTitle>
        <Title align="center">{t("works.title")}</Title>
        <Para>{t("works.para")}</Para>

        <WorksRow>
          {data.map((d) => (
            <ProjectCard key={d._id} data={d} />
          ))}
        </WorksRow>

        <Pagination>
          <PaginationButton
            disabled={!hasPrevious}
            href={`/works?page=${page - 1}`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
              />
            </svg>
          </PaginationButton>
          <PaginationButton
            disabled={!hasNext}
            href={`/works?page=${page + 1}`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
              />
            </svg>
          </PaginationButton>
        </Pagination>
      </Container>
    </SectionWorks>
  );
}

export default index;

const SectionWorks = styled.section`
  padding: 40px 0;
  background-color: var(--white);
`;

const Para = styled.p`
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: var(--grayWhite);
  letter-spacing: 0.2px;
  width: 600px;
  margin: auto;
  @media ${device.laptop} {
    width: 80%;
  }
`;

const WorksRow = styled.div`
  margin: 40px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  @media ${device.laptop} {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  @media ${device.tablet} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const Pagination = styled.div`
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const PaginationButton = styled(Link)<{ disabled: boolean }>`
  background-color: var(--white);
  border: 1px solid var(--grayWhite);
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;
